export enum PathType {
  UNDEFINED = '',
  PROTECTION_JURIDIQUE = 'PJ'
}

export const isPathType = (pathType: string | null): pathType is PathType => {
  switch (pathType) {
    case PathType.PROTECTION_JURIDIQUE:
      return true;
    default:
      return false;
  }
};
